import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { GamificationFacade } from '../state/gamification.facade';
import { RankingType } from '../services/models/ranking.model';

@Component({
  selector: 'app-gamification',
  templateUrl: './gamification.page.html',
  styleUrls: ['./gamification.page.scss'],
})
export class GamificationPage implements OnInit {

  private readonly gamificationFacade = inject(GamificationFacade);
  private readonly configService = inject(ConfigService);

  readonly isLoading$ = this.gamificationFacade.isLoading$;
  readonly badges$ = this.gamificationFacade.badges$;
  readonly monthlyRanking$ = this.gamificationFacade.monthlyRanking$;
  readonly generalRanking$ = this.gamificationFacade.generalRanking$;

  readonly showBadges = signal(this.configService.get().gmfConfig.showBadges);
  readonly showPoints = signal(this.configService.get().gmfConfig.showPoints);
  readonly showRanking = signal(this.configService.get().gmfConfig.showRanking);

  readonly menuTitle = computed(() => this.configService.get().customLabels.ranking.menuTitle ?? 'gamification.ranking.rankingAndMedals');
  readonly rankingTitle = computed(() => {
    if (!this.showRanking() && this.showBadges()) {
      return 'gamification.ranking.titles.points';
    }
    return 'gamification.ranking.titles.ranking';
  });

  readonly rankingType = RankingType;

  ngOnInit(): void {
    this.gamificationFacade.getGamificationData(this.showBadges()).subscribe();
  }
}
